import { useState, useEffect } from "react";
import { Container, Pagination, Table } from "react-bootstrap";
import ShimmerLoader from "../utilComponents/shimmer.js";
import { useDepositHistory } from "../../services/hooks/getApi";

const DepositHistory = () => {
  const [depositHistory, setDepositHistory] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5; // Number of items per page
  const totalPages = Math.ceil(depositHistory.length / itemsPerPage);

  // Fetch deposit history using the custom hook
  const { data: depositHistoryData, isLoading } = useDepositHistory();
  // console.log("Deposit History Data:", depositHistoryData);
  // console.log("Is Loading:", isLoading);
  useEffect(() => {
    if (Array.isArray(depositHistoryData)) {
      setDepositHistory([...depositHistoryData]);
      console.log("Deposit History Data:", depositHistoryData);
      console.log("Deposit History:", depositHistory);
    } else {
      setDepositHistory([]);
    }
  }, [depositHistoryData]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = depositHistory.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  return (
    <>
      <Container className="mt-4 custom-container">
        <h4 className="text-center text-primary">Deposit History</h4>
        <Table striped bordered responsive className="text-center shadow-sm">
          <thead className="bg-primary text-white">
            <tr>
              <th>S.No</th>
              <th>Mode</th>
              <th>Amount</th>
              <th>Time Period</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan="9">
                  <ShimmerLoader width="100%" height="30px" />
                </td>
              </tr>
            ) : currentItems.length > 0 ? (
              currentItems.map((deposit, index) => (
                <tr key={index}>
                  <td>{startIndex + index + 1}</td>
                  <td>{deposit?.deposit_mode}</td>
                  {/* <td>₹{deposit.amount.toLocaleString()}</td> */}
                  <td>
                    ₹
                    {typeof deposit?.amount === "number"
                      ? deposit.amount.toLocaleString()
                      : "N/A"}
                  </td>
                  <td>
                    {deposit?.timePeriod
                      ? `${deposit.timePeriod} Months`
                      : "N/A"}
                  </td>
                  <td>
                    <span
                      className={`badge ${
                        deposit.status === "Approved"
                          ? "bg-success"
                          : deposit.status === "Pending"
                          ? "bg-warning text-dark"
                          : "bg-danger"
                      }`}>
                      {deposit?.status}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9">No deposit requests found</td>
              </tr>
            )}
          </tbody>
        </Table>

        {/* Pagination Controls */}
        <div className="d-flex justify-content-center mt-3">
          <Pagination>
            {[...Array(totalPages)].map((_, pageIndex) => (
              <Pagination.Item
                key={pageIndex}
                active={currentPage === pageIndex + 1}
                onClick={() => handlePageChange(pageIndex + 1)}>
                {pageIndex + 1}
              </Pagination.Item>
            ))}
          </Pagination>
        </div>
      </Container>
    </>
  );
};

export default DepositHistory;
